import fetcher from 'api/fetcher';
import { getIndexByEntityId } from 'utils/clickme';
import { NotificationName } from 'utils/constants/notification';

import { setIdAdminAction, setLoadBannerAdminAction } from 'store/models/adminBannerAction';
import { addNotification } from 'store/models/notification';

export default (campaignId, bannerId) => {
    return (dispatch, getState) => {
        const state = getState();
        const { campaigns } = state.dashboard;
        const index = getIndexByEntityId(campaignId, campaigns, 'id');
        if (index === -1) {
            return null;
        }
        dispatch([setLoadBannerAdminAction(true), setIdAdminAction({ campaignId, bannerId })]);
        return fetcher.get(`/api/v1/banners/${bannerId}/moderation`, { timeout: 60000 }).then(() => {
            dispatch([setLoadBannerAdminAction(false), addNotification(NotificationName.CheckBannerModeration)]);
        });
    };
};
